import { hasItem, countItem } from './inventory.js';
import { spawnPickup } from '../world/pickups.js';

// Four distinct parts the player needs to repair the communicator. Each has a
// unique colour, in-world silhouette, and inventory glyph so they're easy to
// tell apart at a glance.
export const COMM_PARTS = [
  { id: 'comm_antenna', name: 'Antenna Array',  color: 0xc8e0f0, shape: 'dish',  icon: '◉' },
  { id: 'comm_battery', name: 'Power Cell',     color: 0xffc040, shape: 'cell',  icon: '▮' },
  { id: 'comm_board',   name: 'Circuit Board',  color: 0x4cd896, shape: 'board', icon: '▭' },
  { id: 'comm_chip',    name: 'Signal Chip',    color: 0x9a64ff, shape: 'chip',  icon: '▣' },
];

export const COMM_PART_IDS = COMM_PARTS.map((p) => p.id);

export function isCommPart(id) {
  return COMM_PART_IDS.includes(id);
}

export function partsCollectedCount() {
  return COMM_PART_IDS.reduce((n, id) => n + (hasItem(id) ? 1 : 0), 0);
}

export function allPartsCollected() {
  return COMM_PART_IDS.every((id) => hasItem(id));
}

// Scatter one of each part somewhere on the planet. Parts get a vertical
// light beacon so they're spottable across the curve of the surface — the
// "subtle guidance" the player needs without a waypoint HUD. Returns the
// spawned pickup entries so callers (e.g. the dev menu) can reference
// their world positions.
//
// `randomDir` lets the caller control placement — typically used to pass a
// helper that rerolls directions falling inside POI exclusion zones so
// parts never spawn in the pond or through the landing pod.
// `skipIds` excludes parts that are spawned elsewhere (e.g. the Antenna
// Array, which comes from the ruins puzzle).
export function scatterParts(scene, planet, randomDir, skipIds = []) {
  const entries = [];
  for (const part of COMM_PARTS) {
    if (skipIds.includes(part.id)) continue;
    const dir = randomDir ? randomDir() : undefined;
    const entry = spawnPickup(scene, planet, { ...part, beacon: true, dir });
    entries.push({ name: part.name, entry });
  }
  return entries;
}
